<div class="releases-list-container">



  <div class="releases-header d-flex align-items-center justify-content-between mb-4">
    <h1 class="releases-title sdh1 mb-0">
      <span class="d-none d-md-inline">My Music</span>
      <span class="d-inline d-md-none">My Music</span>
    </h1>
    <button (click)="global.openHelpdesk(); global.gAEvents('my_releases', 'help_button')"
      class="releases-help-btn d-flex align-items-center">
      <img src="assets/images/help-headset.svg" alt="Help" class="help-headset-icon" />
      <span class="help-text">Help</span>
    </button>
  </div>


  <!-- Empty state: no releases at all yet, regardless of Pro status -->
  <section *ngIf="songs.length === 0" class="user-status no-releases text-center py-10">
    <div class="row">
      <div class="col-12 mt-4">
        <div class="p-20 t-c successContainer">
          <img src="../../../assets/images/opps-emoji.png" alt="Opps Image" class="mt-4 mb-2" width="25px"
            height="25px">
          <h2>Oh No!</h2>
          <h3>You have not distributed your music with us yet!</h3>
          <p class="mt-4 mb-4 distribute-sub">
            Distribute your track with us to get it live on Spotify, Apple Music, and more.
          </p>
        </div>
        <div class="flex-c-c mt-4">
          <button class="Dbutton" routerLink="/distribute/release"
            (click)="global.gAEvents('my_releases', 'release_your_music')">
            Distribute Now
          </button>
        </div>
      </div>
    </div>
  </section>

  <div *ngIf="songs.length > 0" class="tabs-filter-row d-flex align-items-center justify-content-between mb-4 flex-wrap">

    <ul class="nav mb-0">
      <li class="nav-item sd-navItem sd-mr-12 sd-mr-md-8 sd-mr-sm-4 active" routerLink="/distribute/my-releases"
        (click)="global.gAEvents('my_release', 'release_button')">
        Releases
      </li>
      <li class="nav-item sd-navItem" routerLink="/mydashboard/songs"
        (click)="global.gAEvents('my_release', 'upload_button')">
        Uploads
      </li>
    </ul>


    <div class="dropdown filter-dropdown mt-2 mt-md-0">
      <div class="btn btn-filter dropdown-toggle d-flex align-items-center" type="button" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#718096"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2">
          <line x1="4" y1="21" x2="4" y2="14"></line>
          <line x1="4" y1="10" x2="4" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12" y2="3"></line>
          <line x1="20" y1="21" x2="20" y2="16"></line>
          <line x1="20" y1="12" x2="20" y2="3"></line>
          <line x1="1" y1="14" x2="7" y2="14"></line>
          <line x1="9" y1="8" x2="15" y2="8"></line>
          <line x1="17" y1="16" x2="23" y2="16"></line>
        </svg>
        <span class="filter-label mr-2">{{ currentFilter }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#718096"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="ml-1">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
      <div class="dropdown-menu dropdown-menu-right">
        <a class="dropdown-item" role="button" tabindex="0" [class.active]="currentFilter === 'All'"
          (click)="setFilter('All')">All ({{
          songs.length }})</a>
        <a class="dropdown-item" role="button" tabindex="0" [class.active]="currentFilter === 'Drafts'"
          (click)="setFilter('Drafts')">Drafts
          ({{ draftsCount }})</a>
        <a class="dropdown-item" role="button" tabindex="0" [class.active]="currentFilter === 'In Process'"
          (click)="setFilter('In Process')">In Process ({{ inProcessCount }})</a>
        <a class="dropdown-item" role="button" tabindex="0" [class.active]="currentFilter === 'Live'"
          (click)="setFilter('Live')">Live ({{
          liveCount }})</a>
        <a class="dropdown-item" role="button" tabindex="0" [class.active]="currentFilter === 'Action Required'"
          (click)="setFilter('Action Required')">Action Required ({{ actionRequiredCount }})</a>
        <a class="dropdown-item" role="button" tabindex="0" [class.active]="currentFilter === 'Terminated'"
          (click)="setFilter('Terminated')">Terminated ({{ terminatedCount }})</a>
      </div>
    </div>
  </div>


  <div *ngIf="songs.length > 0" class="d-flex align-items-center justify-content-between subheader-row pb-2 mb-3">
    <h2 class="section-heading sdh2 mb-0">Releases</h2>
    <div class="d-flex align-items-center">
      <a class="action-btn-link d-flex align-items-center" routerLink="/distribute/release"
        (click)="global.gAEvents('my_releases', 'release_your_music')">
        Distribute Your Music
      </a>
    </div>
  </div>


  <div class="cards-list">
    <div *ngFor="let song of filteredSongs; let i = index" class="release-card song-card">


      <div class="d-flex align-items-center mb-2 promoTool pointer" *ngIf="song.piorder?.length > 0"
        (click)="$event.stopPropagation()"
        routerLink="/promote/{{song.album_id == 0 ? 'song' : 'album'}}/{{ song.slug }}/{{song.piorder[0].tool_name}}">
        <img src="../../../assets/images/blue_star.png" alt="Promo" class="mr-2" width="16" height="16" />
        <span class="labelText">{{ song.piorder[0].message }}</span>
      </div>

      <div class="row align-items-center my-release-card">

        <div class="col-auto pr-0">
          <div class="artwork-wrapper" [class.artwork-wrapper-clickable]="getDistributionStatus(song) === 'Live'"
            (click)="onArtworkClick(song, $event)">
            <img [lazyLoad]="song?.image + '?w-200'"
              [style.filter]="(getDistributionStatus(song) === 'Terminated' || getDistributionStatus(song) === 'On hold') ? 'grayscale(100%)' : 'none'"
              class="artwork-img songArtWork"
              defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png"
              [alt]="song.title" />
          </div>
        </div>

        <div class="col card-detail-section pl-3">
          <div class="d-flex align-items-center mb-1 flex-wrap">
            <span class="badge-type mr-3" [ngClass]="song.album_id == 0 ? 'badge-single' : 'badge-album'">
              {{ song.album_id == 0 ? 'Single' : 'Album' }}
            </span>
          </div>

          <h4 class="songTitleText mb-1" [class.song-title-terminated]="getDistributionStatus(song) === 'Terminated'">
            {{ (song.title.length > 20) ? (song.title | slice:0:20) + '...' : song.title }}
          </h4>

          <h4 class="infoText mb-0">
            Release : {{ song.agreement < 1 ? global.formatedDate(song.created_date) :
              global.formatedDate(song.release_date) }} </h4>
        </div>


        <div class="d-flex flex-row flex-md-column status-icons-column px-3">
          <ng-container *ngTemplateOutlet="statusIconsTemplate"></ng-container>
        </div>

        <ng-template #statusIconsTemplate>
          <div class="d-flex align-items-center mb-0 mb-md-2 status-row">
            <span class="status-icon audio-icon mr-2" aria-hidden="true">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#A0A0A0" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                <path
                  d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z">
                </path>
              </svg>
            </span>
            <span class="status-label mr-1">Audio</span>
            <ng-container *ngIf="getDistributionStatus(song) as audioStatus">
              <span class="status-separator mr-1" [ngClass]="getDistributionStatusClass(song)">&bull;</span>
              <span class="status-badge" [ngClass]="getDistributionStatusClass(song)">
                {{ audioStatus }}
              </span>
            </ng-container>
          </div>
          <div class="d-flex align-items-center status-row"
            [class.video-status-faded]="getDistributionStatus(song) !== 'Live'">
            <span class="status-icon video-icon mr-2" aria-hidden="true">
              <img *ngIf="getDistributionStatus(song) === 'Live'; else videoIconDisabled"
                src="../../../assets/images/video-status-icon-enabled.svg" alt="" width="20" height="14" />
              <ng-template #videoIconDisabled>
                <img src="../../../assets/images/video-status-icon-disabled.svg" alt="" width="20" height="14" />
              </ng-template>
            </span>
            <span class="status-label mr-1">Video</span>
            <ng-container *ngIf="getVideoStatus(song) as videoStatus">
              <span class="status-separator mr-1" [ngClass]="videoStatus.cssClass">&bull;</span>
              <span class="status-badge" [ngClass]="videoStatus.cssClass">
                {{ videoStatus.label }}
              </span>
            </ng-container>
          </div>
        </ng-template>

        <div class="col-12 col-md-auto text-right action-buttons-section mt-3 mt-md-0">
          <div
            class="d-flex align-items-center justify-content-between justify-content-md-end flex-wrap action-buttons-row">

            <button class="btn-primary-action mr-md-2" type="button"
              (click)="onPrimaryAction(song); $event.stopPropagation()">
              {{ getPrimaryActionLabel(song) }}
            </button>

            <div class="dropdown card-menu-dropdown">
              <img src="../../../assets/images/three-dot-menu-icon.svg" class="dots-icon dropdown-toggle"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt="More options" />
              <div class="dropdown-menu dropdown-menu-right card-menu" [ngSwitch]="getActionMenuMode(song)">
                <a class="card-menu-item" role="button" tabindex="0" *ngSwitchCase="'delete'"
                  (click)="showDeleteWarning(i)">
                  Delete
                </a>
                <ng-container *ngSwitchCase="'promote'">
                  <a class="card-menu-item" role="button" tabindex="0" [class.disabled]="song.agreement < 1"
                    routerLink="/promote/{{song.album_id == 0 ? 'song': 'album'}}/{{song.slug}}"
                    (click)="global.gAEvents('my_release', 'promote_button', song.title, song.album_id == 0 ? 'single' : 'album')">
                    Promote
                  </a>
                  <div class="card-menu-divider"></div>
                  <a class="card-menu-item" role="button" tabindex="0"
                    (click)="global.openHelpdesk(); global.gAEvents('my_releases', 'help_button')">
                    Helpdesk
                  </a>
                </ng-container>
                <a class="card-menu-item" role="button" tabindex="0" *ngSwitchCase="'helpdesk'"
                  (click)="global.openHelpdesk(); global.gAEvents('my_releases', 'help_button')">
                  Helpdesk
                </a>
              </div>
            </div>

          </div>
        </div>

      </div>


      <div class="delete-warning-panel mt-3" *ngIf="warningStates[i]" #warningElement
        (click)="$event.stopPropagation()">
        <p class="delete-warning-text mb-0">Are you sure you want to delete this
          {{ song.album_id > 0 ? 'album' : 'song' }}?</p>
        <div class="d-flex justify-content-center delete-warning-actions">
          <button class="button" (click)="confirmDelete(warningElement, song, i); $event.stopPropagation()">Yes,
            Delete</button>
          <button class="btn-delete-cancel" (click)="hideDeleteWarning(i); $event.stopPropagation()">Cancel</button>
        </div>
        <mat-error class="mt-2 d-block"></mat-error>
      </div>

    </div>
  </div>


  <div class="load-more-wrapper text-center mt-5" *ngIf="songs.length > 0 && songs.length < totalCount">
    <button class="button" [disabled]="moreLoading" (click)="loadMore()">
      <span *ngIf="!moreLoading">Load More</span>
      <span *ngIf="moreLoading">Loading...</span>
    </button>
  </div>
</div>